import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { Text } from 'react-native-paper'
import { commonColors } from '../../../../common-frontend/src/theme'
import CommonInput from '../../ui/atoms/builder-2.0/CommonInput'

interface PasswordInputProps {
  value: string
  onChangeText: (arg1: string) => void
  editable?: boolean
  onSubmitEditing?: () => void
  newPassword?: boolean
  confirmation?: boolean
  showEye: boolean
  inputRef?: any
  testID: string
  label: string
  mandatory?: boolean
}

export default function PasswordInput({
  value = '',
  onChangeText,
  editable = true,
  onSubmitEditing,
  newPassword,
  confirmation = false,
  showEye,
  inputRef = null,
  testID = 'password',
  ...props
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false)
  const { accentText } = commonColors

  const autoComplete =
    newPassword || confirmation ? 'new-password' : 'current-password'
  const placeholder = confirmation
    ? 'Both passwords must match'
    : '8 characters, 1 uppercase, 1 number'

  return (
    <View>
      <CommonInput
        testID={testID}
        name={confirmation ? 'password-confirm' : autoComplete}
        value={value}
        onChangeText={onChangeText}
        editable={editable}
        placeholder={placeholder}
        onSubmitEditing={onSubmitEditing}
        secureTextEntry={!visible}
        autoComplete={autoComplete}
        ref={inputRef}
        {...props}
      />
      {showEye && (
        <View style={styles.iconWrapper}>
          <Text
            style={{ fontWeight: '500', fontSize: 14, color: accentText }}
            onPress={() => setVisible((v) => !v)}
            testID="show-link"
          >
            {visible ? 'HIDE' : 'SHOW'}
          </Text>
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  iconWrapper: {
    position: 'absolute',
    bottom: 17,
    left: undefined,
    height: 20,
    right: 15,
    justifyContent: 'center',
  },
})
